var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThinkdiffusionLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 152.9",
    style: {
      enableBackground: "new 0 0 1080 152.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#63BF76;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,121.7V59.9L0,60.7V31.2h69.2v29.4l-18.5-0.8v61.9H18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,121.7V31.2h31.6v30.7h20.1V31.2h31.6v90.5h-31.6V90.2h-20.1v31.5H74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.8,121.7V31.2h32.8v90.5H165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.6,121.7V31.2H238l21,34.2c3.4,5.4,5.6,9,8.5,16h0.9c-1.4-5.7-2.8-14.8-2.8-21.4V31.2h31.5v90.5h-31.5 L243.1,86c-2-3.3-4.5-8-6.2-11.8h-0.9c0.9,4.9,2,12.6,2,16.7v30.8H206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.1,121.7V31.2h31.5v28.1c0,4.1-0.1,7.3-0.7,11.4h0.7c1.9-5.2,3.1-7.2,4.7-10.2L357,31.2h35.5l-28.2,44.4 l31.2,46.1h-38l-16.6-29c-1.6-2.7-3.1-6-4.3-8.7h-0.7c0.5,3.1,0.7,5.6,0.7,8.5v29.2H305.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510,121.7V31.2h32.8v90.5H510z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M550.8,121.7V31.2h60.4V57h-27.5v9.2h24.2v23.9h-24.2v31.6H550.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.9,121.7V31.2h60.4V57h-27.5v9.2h24.2v23.9h-24.2v31.6H616.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M683,31.2h32.6v52.5c0,2.7,0.3,6.5,2.8,9.2c1.8,1.9,3.9,2.4,6.5,2.4c3.4,0,5.4-1,6.6-2.2 c2.4-2.4,2.4-7.2,2.4-9.5V31.2h32.7v55.5c0,7.1-1.4,17.4-9.5,25.8c-9.2,9.5-22.3,11.3-32.3,11.3c-8.3,0-23.3-0.8-33.6-11.9 c-7.1-7.6-8.3-16.1-8.3-22.8V31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M832.7,60.1c-3.9-2.7-11.1-6.8-18.5-6.8c-1.8,0-4.5,0.3-6.2,1.6c-1.2,0.9-1.6,1.9-1.6,3.3 c0,1.9,0.3,3.7,5.3,4.7l10.4,2.3c8,1.8,12.8,5,15.5,7.7c5.7,5.6,6.9,12.5,6.9,17.9c0,7.7-2,14.9-8.1,21.3 c-5.2,5.3-14.9,11.5-31.9,11.5c-13.8,0-23.1-3.9-30.8-7.1l-3-1.2l9.9-25.5l3.5,2.7c3.4,2.6,10.3,6.6,18.3,6.6 c4.5,0,6.4-1.1,7.1-1.6c1.5-1.2,1.8-2.7,1.8-4.1c0-0.8-0.1-2.2-1.1-3.1c-1.1-1.1-2.8-1.5-6.2-2.2l-8-1.5 c-5.2-0.9-10.7-2.6-15.7-7.7c-4.6-4.7-6.5-10.2-6.5-16.7c0-8.4,2.8-15.6,8.8-21.6c6.9-7.1,17.1-11.7,31.5-11.7 c7.2,0,16.6,1.2,27.5,7.9L832.7,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M848.4,121.7V31.2h32.8v90.5H848.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M972.9,109.2c-7.7,7.9-20.4,14.5-37.6,14.5c-17.2,0-29.8-6.6-37.6-14.5c-7.1-7.2-12.6-18.3-12.6-32.8 c0-14.4,5.6-25.5,12.6-32.7c7.7-7.9,20.4-14.5,37.6-14.5c17.2,0,29.9,6.6,37.6,14.5c7.1,7.2,12.6,18.3,12.6,32.7 C985.6,90.9,980,102,972.9,109.2z M923.6,63c-3.3,3.4-5.2,8.7-5.2,13.6c0,5.2,1.9,10.2,5.2,13.4c2.7,2.7,6.8,4.6,11.8,4.6 c5,0,9.1-1.9,11.8-4.6c3-3,5.2-7.7,5.2-13.4c0-5.7-1.9-10.4-5.2-13.6c-2.4-2.4-6.4-4.6-11.8-4.6C929.5,58.4,925.7,60.7,923.6,63z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M989.5,121.7V31.2h31.3l21,34.2c3.4,5.4,5.6,9,8.5,16h0.9c-1.4-5.7-2.8-14.8-2.8-21.4V31.2h31.5v90.5h-31.5 L1026,86c-2-3.3-4.5-8-6.2-11.8h-0.9c0.9,4.9,2,12.6,2,16.7v30.8H989.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.6,76.5c0-42.2-34.2-76.5-76.5-76.5v0h-31.2c0,17.2,14,31.2,31.2,31.2v0c25,0,45.2,20.3,45.2,45.2 s-20.3,45.2-45.2,45.2l0,0c-17.2,0-31.2,14-31.2,31.2h31.2l0,0C467.3,152.9,501.6,118.7,501.6,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.3,90.7c7.8-7.8,7.8-20.6,0-28.4c-7.8-7.8-20.6-7.8-28.4,0c0,0,0,0,0,0l0,0l-14.2,14.2l14.2,14.2 C418.8,98.5,431.5,98.5,439.3,90.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkdiffusionLogoColor);
export default __webpack_public_path__ + "static/media/thinkdiffusion-logo-color.13f87b42bc73087b7707382c1c5b57ec.svg";
export { ForwardRef as ReactComponent };